import { QuoteFormContent } from '@/features/quotations/components/QuoteFormContent'
import { useParams } from 'react-router-dom'

export default function RequestQuoatationPage() {
  const { quatationId } = useParams()

  return <QuoteFormContent quatationId={quatationId!} />
}
